<template>
  <div>
    <loading v-show="!showLoading"></loading>
    <div class="game_Prize">
      <div v-show="showLoading" class="game_box">
<!--        <div class="game_Prize_bg">-->
<!--          <div @click="$router.back(-1)" class="game_wbg_return">-->
<!--            <img src="@/images/back.png" class="game_wbg_kt">-->
<!--          </div>-->
<!--          <div class="game_shae">我的奖品</div>-->
<!--        </div>-->

        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="game_Prize_top">
          <div class="game_Prize_ter" v-if="emptyList">您未抽中活动奖品</div>
          <div class="game_Prize_ci_in"></div>
          <div class="game_Prize_ci" v-for="presentItem in presentList">
            <div class="game_Prize_vun">
              <div class="game_Prize_left fl">{{presentItem.prizeName}}</div>
              <div class="game_Prize_right fr">
                <div class="Prize_right_button" @click="goReceive(presentItem)" v-if="presentItem.statusId=='未发送' || presentItem.statusId=='领取中'">立即领取</div>
                <div class="Prize_right_button2" v-if="presentItem.statusId!='未发送'&&presentItem.statusId!='领取中'&&presentItem.statusId!='审核中'">已领取</div>
                <div class="Prize_right_button3" v-if="presentItem.statusId=='审核中'">已提交</div>
              </div>
            </div>
            <div class="game_Prize_vun game_Prize_text">参与时间：{{dateFormat('yyyy.MM.dd hh:mm:ss', new Date(presentItem.recordDate))}}</div>
            <div class="game_Prize_vun game_Prize_text">游戏名称：{{presentItem.lotteryActivityName}}</div>
          </div>
          <div class="game_Prize_ci_in"></div>
          <refresh class="fl full_w" style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: presentList.length,show:show}'></refresh>
          <!--中奖的三种状态  红包 K币 优惠券-->
          <!--领取微信红包弹框-->
          <van-popup v-model="showPrcoupon" class="num_popup">
            <!--          <div class="num_popup_close" @click="=false">-->
            <!--            <img src="@/images/BindCard_Icon_Delete@3x.png">-->
            <!--          </div>-->
            <div class="num_popup_text">领取红包方式</div>
            <div class="num_popup_li">1. 扫下方二维码关注“杭州Hello Kitty乐园”官方服务号；</div>
            <div class="num_popup_li">2. 请确保您已开通微信钱包功能并正常使用；</div>
            <div class="num_popup_li">3. 红包金额通过微信支付发送到您的微信钱包中，预计在24小时内到帐，部分时段会有延迟；</div>
            <div class="popup_code">
              <img src="@/images/game_qr_code.jpg" class="game_qr_code" />
            </div>
            <!--          <div class="num_popup_button" v-if="prizeredMin" @click="goprizeredMin=true,prizeredMin=false">领取红包</div>-->
            <div class="num_popup_button" v-if="prizeredMin" @click="setPresentToUserAction()">领取红包</div>
            <div class="num_popup_button2" v-if="goprizeredMin">红包发送中</div>
            <div class="num_popup_button2" v-if="goprizeredTon">红包已发送</div>
          </van-popup>

          <!--领取活动金币弹框-->
          <van-popup v-model="showPrcurrency" class="num_currency">
            <!--          <div class="num_popup_close" @click="showPrcurrency=false">-->
            <!--            <img src="@/images/BindCard_Icon_Delete@3x.png">-->
            <!--          </div>-->
            <div class="num_currency_text">K币发送成功，请进入个人中心查看</div>
          </van-popup>

          <!--领取活动金币弹框-->
          <van-popup v-model="showCash" class="num_cash">
            <div class="num_cash_text">兑换方式</div>
            <div class="num_cash_li">请填写您的姓名、手机号及身份证号，并凭有效证件至乐园现场领奖</div>
            <div class="num_cash_input">
              <div class="num_cash_box">
                <div class="fl num_cash_inter">姓名</div>
                <van-cell-group class="cash_input fr" >
                    <van-field v-model="gameValuename" placeholder="请输入姓名" class="van-cell-lin" :value="productPromoName"  />
                </van-cell-group>
              </div>
            </div>
            <div class="num_cash_input">
              <div class="num_cash_box">
                <div class="fl num_cash_inter">手机号</div>
                <van-cell-group class="cash_input fr">
                  <van-field v-model="gameValuephone" placeholder="请输入手机号" class="van-cell-lin" :value="productPromoMobile" />
                </van-cell-group>
              </div>
            </div>
            <div class="num_cash_input">
              <div class="num_cash_box">
                <div class="fl num_cash_inter">身份证</div>
                <van-cell-group class="cash_input fr" >
                  <van-field v-model="gameValueID" placeholder="请输入身份证" class="van-cell-lin" :value="productPromoCardNo" />
                </van-cell-group>
              </div>
            </div>
            <div class="num_button_box">
              <div class="num_button_left" @click="showCash=false">取消</div>
              <div class="num_button_right" @click="showCashPush()">提交</div>
            </div>
          </van-popup>
          <div class="game_left_button" @click="$router.back(-1)">返回</div>
        </van-pull-refresh>
      </div>

    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { storeName,prodCatalogId,loginInfo,productRecommend,severUrl ,shareOnlineUrl} from '@/router/Constant'
import { getUserInfo,getProductAttributes,getGameInfo,setGameAction,getPresentList,setPresentToUser,getWinRecordList} from '@/router/api';
import { setStore,getStore,getCookie,setCookie ,setMiniProgramShare, isCardNo, isPhone} from '@/utils/mUtil';
import { NavBar,Swipe,SwipeItem,Image,Grid,Tabbar,Toast,Search,PullRefresh,Dialog,Popup,List,Cell,Field,CellGroup } from 'vant';
import footerView from '../common/footer';
import loading from '@/components/page/common/loading.vue'
import refresh from '@/components/page/common/refresh.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: "gamePrize",

  data() {
    return {
      presentList:[],
      viewIndex:0,
      viewSize:20,
      showNum:false,
      // gameId:this.$route.query.gameId,
      emptyList:false,
      showListView:false,
      showRuleView:false,
      allLoaded:false,
      show:false,
      showPrcoupon:false,
      showPrcurrency: false,
      prizeType:"",
      goButton: true,
      oNButton: false,
      prizeVun:'',
      prizeredMin: true,
      goprizeredMin: false,
      goprizeredTon: false,
      showLoading: false,
      showReceiving: false,
      isLoading: false,
      showCash:false,
      gameValuename:'',
      gameValuephone:'',
      gameValueID:'',
      productPromoName:'',
      productPromoMobile:'',
      productPromoCardNo:'',

    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Grid.name]: Grid,
    [Tabbar.name]: Tabbar,
    [Toast.name]: Toast,
    [Search.name]: Search,
    [PullRefresh.name]: PullRefresh,
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    footerView,
    loading,
    refresh,
    vueSeamlessScroll,
    Vue,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup
  },
  methods:{
    dateFormat (fmt, date) {
      let ret;
      let opt = {
        "y+": date.getFullYear().toString(),        // 年
        "M+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
        'h+': date.getHours().toString(),
        'm+': date.getMinutes().toString(),
        's+': date.getSeconds().toString(),
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
      };
      return fmt;
    },
    async initMont() {
      this.getPresentListAction();
    },

    //中奖记录
    getPresentListAction(){
      var param = {
        externalLoginKey:getStore('externalLoginKey'),
        unionId:getStore('unionId'),
        // gameId:this.gameId,
        viewIndex:this.viewIndex,
        viewSize: this.viewSize
      }
      getPresentList(param)
        .then(res => {
          console.log('getPresentList')
          console.log(res)
          this.presentList = res.presentList
          this.showLoading = true
          if (res.listSize > 0) {
            this.emptyList = false
          } else {
            this.emptyList = true
          }
        })
        .catch(err => {
          console.log(err)
          Toast.fail(err);
          this.showLoading = true
          this.emptyList = true
        });
    },

    setPresentToUserAction(type){
      var param = {
        externalLoginKey:getStore('externalLoginKey'),
        lotteryRecordId:this.lotteryRecordId,
        name:this.gameValuename,
        mobile: this.gameValuephone,
        cardNo:this.gameValueID,
        productPromoId:this.productPromoId,
        productPromoRuleId:this.productPromoRuleId,
      }
      console.log(param)
      return setPresentToUser(param)
        .then(res => {
          console.log('setPresentToUser')
          console.log(res)
          // debugger
          this.productPromoIdLint = res.productPromoId
          this.productPromoRuleIdLint = res.productPromoRuleId

          this.productPromoName = res.name
          this.productPromoMobile = res.mobile
          this.productPromoCardNo = res.cardNo
          if (!res._ERROR_MESSAGE_) {
            this.goprizeredMin = false
            this.goprizeredTon = true
            this.prizeredMin = false
            if (type == 'COUPON') {
              this.$router.push({name:'giveawayList',query:{productPromoId:this.productPromoIdLint,productPromoRuleId:this.productPromoRuleIdLint}})
            }
          } else {
            this.goprizeredMin = true
            this.goprizeredTon = false
            this.prizeredMin = false
            Toast(res._ERROR_MESSAGE_)
          }
        })
        .catch(err => {
          Toast.fail(err);
        });
    },


    async goReceive(item){
      // debugger
      let _this = this;
      console.log(item)
      var typeName = '';

      this.lotteryRecordId = item.lotteryRecordId;

      switch (item.prizeType) {
        // 产品
        case 'PRODUCT':
          if (getStore('currentGameAddress')!=undefined&&getStore('currentGameAddress')!='') {
          } else {
            typeName = '选择收货地址'
          }
          this.showCash = true
          // 优惠券跳转
          break
        // 奖金
        case 'BONUS':
          // typeName = '开心收下'
          // 红包提示弹出
          this.showPrcoupon = true
          break
        case 'POINT':
          // k币提示弹出
          this.showPrcurrency = true
          break
        case 'COUPON':
          // typeName = '开心收下'
          console.log(_this.statusId)
          // this.lotteryRecordId = item.lotteryRecordId;
          console.log(item)
          if (item.statusId == '领取中') {
            this.$router.push({name:'giveawayList',query:{productPromoId:item.productPromoId,productPromoRuleId:item.productPromoRuleId}})
          } else {
            _this.setPresentToUserAction('COUPON')
          }
          break
        case '':
          typeName = '再接在励'
          break
        default:
          typeName = '再接在励'
      }
      return typeName
    },

    showCashPush(){
      if(!this.gameValuename){
        return Toast('请输入姓名');
      }
      if(!isPhone(this.gameValuephone)) {
        return Toast('手机号输入错误');
      }
      if(!isCardNo(this.gameValueID)) {
        return Toast('身份证输入错误');
      }
      this.setPresentToUserAction();

      if (this.gameValuename && this.gameValuephone && this.gameValueID) {
        Toast('提交成功');
        this.showCash = false
      } else {
        Toast('提交失败');
      }

    },


    //下拉刷新
    onRefresh() {
      console.log(1);
      setStore('onRefresh',"onRefresh")
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },


    //上拉加载
    loadMore() {
      if (!this.allLoaded) {
        this.viewIndex ++;
        var param = {
          externalLoginKey:getStore('externalLoginKey'),
          unionId:getStore('unionId'),
          // gameId:this.gameId,
          viewIndex:this.viewIndex,
          viewSize: this.viewSize
        }
        console.log(param)
        getPresentList(param)
          .then(res => {
            console.log("getPresentList")
            console.log("上拉加载")
            console.log(res)
            this.show = true
            if (res.presentList.length < this.viewSize) {
              this.allLoaded = true
            } else {
              this.allLoaded = false
            }
            var oldProductList = this.presentList
            var newProductList = oldProductList.concat(res.presentList)
            this.presentList = newProductList
            this.viewIndex = res.viewIndex;
          })
          .catch(err => {
            console.log(err);
          });
      }
    },



  },


  mounted() {
    this.initMont();
  },
}
</script>
<style scoped>
html{ background: #c61a1a}
.game_Prize{ width: 23.43rem; height: auto; background: #fbfbfb;}
.game_Prize_ko{ width: 23.43rem; height: 3.3rem}
.game_Prize_to{ width: 23.43rem; height: 1rem}
.game_Prize_bg{ width: 23.43rem; height: 3rem; background: #ffffff; position: fixed;top: 0; left: 0; z-index: 1}
.game_assets{ width: 23.43rem; height: 3rem; position: absolute; top: 0; left: 0; background: #ffffff}
.game_wbg_kt{ width: 1.5rem;}
.game_wbg_return{width: 1.5rem; position: absolute; left: 0.6rem; top: 0.7rem }
.game_shae{ position: absolute; top: 0.8rem; left: 2.5rem; font-weight: bold}
.game_Prize_in{ width: 22rem; height: 3rem; margin: 0 auto; border-bottom: 2px solid #F5D517; display: flex; justify-content: center; align-items: center; color: #F5D517}
.game_Prize_li1{ width: 5rem; height: 3rem; text-align: center; line-height: 3rem; font-size: 16px; font-weight: bold}
.game_Prize_li2{ width: 5rem; height: 3rem; text-align: center; line-height: 3rem; font-size: 16px;font-weight: bold}
.game_Prize_li3{ width: 8rem; height: 3rem; text-align: center; line-height: 3rem; font-size: 16px; font-weight: bold}
.game_Prize_li4{ width: 5rem; height: 3rem; text-align: center; line-height: 3rem; font-size: 16px; font-weight: bold}
.game_Prize_ten1{ width: 5rem; height: 3rem; text-align: center;}
.game_Prize_ten2{ width: 5rem; height: 3rem; text-align: center;}
.game_Prize_ten3{ width: 8rem; height: 3rem; text-align: center;}
.game_Prize_ten4{ width: 5rem; height: 3rem; text-align: center;}
.game_Prize_tson{display: flex; justify-content: center; align-items: center; font-size: 12px}
.game_Prize_button{ width: 4rem; height: 1.5rem; background: #ffe400; border-radius: 2rem; line-height: 1.5rem; text-align: center; color: #ffffff}
.game_Prize_button2{ width: 4rem; height: 1.5rem; background: #bbbbbb; border-radius: 2rem; line-height: 1.5rem; text-align: center; color: #ffffff}
.game_Prize_in:last-child{ margin-bottom: 2rem}
.num_popup{
  width:18rem;
  height: 23rem;
  border-radius: 0.625rem;
  background: #ffffff;
}
.num_popup_text{ width: 18rem; text-align: center; font-size: 1.5rem; padding-top: 1.2rem}
.num_popup_li{ width: 17rem; padding-left: 0.5rem; padding-right: 0.5rem; padding-top: 1rem; font-size: 0.8rem}
.popup_code{ width: 4.5rem; height: 4.5rem; position: relative; margin: 0 auto; top: 1rem;}
.game_qr_code{ width: 4.5rem; height: 4.5rem;}
.num_popup_button{ width: 15rem; height: 2rem; background: #eb7aa0; position: relative; margin: 0 auto; top: 2rem; border-radius: 1rem; text-align: center; line-height: 2rem; color: #ffffff;font-size: 0.8rem}
.num_popup_button2{ width: 15rem; height: 2rem; background: #bbbbbb; position: relative; margin: 0 auto; top: 2rem; border-radius: 1rem; text-align: center; line-height: 2rem; color: #ffffff;font-size: 0.8rem}
.num_popup_close{ width: 1.2rem; height: 1.2rem; position: absolute; top: 0.3rem; right: 0.3rem}
.num_popup_close img{ width: 1.2rem; height: 1.2rem;}
.num_currency{
  width:18rem;
  height: 7rem;
  border-radius: 0.625rem;
  background: #ffffff;}

.num_cash{
  width:20rem;
  height: 23rem;
  border-radius: 0.625rem;
  background: #ffffff;}

.num_cash_tan{
  width:10rem;
  height: 3rem;
  border-radius: 0.625rem;
  background: #ffffff;
text-align: center;
  line-height: 3rem;
}

.num_currency_text{ width: 18rem; height: 7rem; font-size: 1rem; text-align: center; line-height: 7rem; color: red}
.game_Prize_ci{ width: 20.5rem; height: 7rem; position: relative; margin: 0 auto; background: #ffffff; padding-left: 0.6rem; padding-right: 0.6rem; margin-top: 0.7rem; border-radius: 0.5rem}
.game_Prize_vun{ width: 20.5rem; height: 2rem; line-height: 2rem}
.Prize_right_button{ width: 4.5rem; height: 1.5rem; background: #eb7aa0; border-radius: 2rem; line-height: 1.5rem; text-align: center; color: #ffffff; display: flex; justify-content: center; align-items: center; font-size: 0.8rem;}
.game_Prize_left{ font-size: 0.9rem; font-weight: bold}
.game_Prize_text{ font-size: 0.8rem; color: #4A4A4A}
.game_Prize_vun:nth-child(1){ padding-top: 0.5rem}
.Prize_right_button2{  width: 4.5rem; height: 1.5rem; background: #bbbbbb; border-radius: 2rem; line-height: 1.5rem; text-align: center; color: #ffffff; display: flex; justify-content: center; align-items: center; font-size: 0.8rem;}
.Prize_right_button3{  width: 4.5rem; height: 1.5rem; background: #bbbbbb; border-radius: 2rem; line-height: 1.5rem; text-align: center; color: #ffffff; display: flex; justify-content: center; align-items: center; font-size: 0.8rem; position: absolute; top: 0.7rem}
.game_Prize_ter{ width: 23.43rem; height: 10rem; display: flex; justify-content: center; align-items: center}
.Prize_right_imgif{ width: 1rem; padding-left: 0.2rem}
/*.game_Prize_top{ margin-top: 3.8rem}*/
.game_Prize_ci_in{ width: 20.5rem; height: 0.8rem}
.num_cash_text{
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  padding-bottom: 0.7rem;
  padding-top: 0.7rem;
}
.num_cash_li{
  padding-left: 2rem;
  padding-right: 2rem;
  margin-top: 1rem;
}
.num_cash_input{ width: 20rem; height: 2rem;  margin-top: 1.2rem; display: flex; justify-content: center;  align-items: center}
.cash_input{ width: 10.5rem; height: 1.8rem;  margin-left: 2rem; }
.num_cash_box{ width: 16rem; height: 2rem;}
.num_cash_inter{ line-height: 2rem}
.num_button_box{ width: 20rem; height: 2rem; margin-top: 2rem}
.num_button_left{ width: 5rem; height: 2rem; background: #ed7796; float: left; margin-left: 3rem; text-align: center; line-height: 2rem; color: #ffffff; border-radius: 0.5rem}
.num_button_right{ width: 5rem; height: 2rem; background: #ed7796; float: right; margin-right: 3rem; text-align: center; line-height: 2rem; color: #ffffff;  border-radius: 0.5rem}
.van-cell-lin{ height: 2rem; line-height: 2rem; padding: 0 0.5rem; border: 1px solid}
.game_Prize_right{
  width: 4.5rem;
  height: 1.5rem;
  margin-top: 0.2rem;
  position: relative;
}
.game_Prize_ci_in{ width: 20.5rem; height: 0.8rem}
.game_left_button{ width: 5rem; height: 1.8rem; background: rgba(000,000,000,0.2); position: fixed; top: 0.5rem; left: 0.5rem; border-radius: 1rem; color: #ffffff; text-align: center; line-height: 1.8rem}
</style>



// WEBPACK FOOTER //
// src/components/page/game/gamePrize.vue